import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services/api'

export const fetchMerchants = createAsyncThunk(
  'merchants/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await api.get('/api/v1/merchants', { params }).then(r => r.data)
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || e.message)
    }
  }
)

export const fetchMerchantById = createAsyncThunk(
  'merchants/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      return await api.get(`/api/v1/merchants/${id}`).then(r => r.data)
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || e.message)
    }
  }
)

export const updateMerchantStatus = createAsyncThunk(
  'merchants/updateStatus',
  async ({ id, status }, { rejectWithValue }) => {
    try {
      return await api.patch(`/api/v1/merchants/${id}/status`, { status }).then(r => r.data)
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || e.message)
    }
  }
)

const merchantsSlice = createSlice({
  name: 'merchants',
  initialState: {
    list:     [],
    selected: null,
    loading:  { list: false, detail: false },
    errors:   {},
    filters:  { riskTier: '', category: '', status: '', search: '' },
  },
  reducers: {
    setMerchantFilter(state, { payload }) {
      state.filters = { ...state.filters, ...payload }
    },
    resetMerchantFilters(state) {
      state.filters = { riskTier: '', category: '', status: '', search: '' }
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchMerchants.pending,   (s)    => { s.loading.list = true;   s.errors.list   = null })
    b.addCase(fetchMerchants.rejected,  (s, a) => { s.loading.list = false;  s.errors.list   = a.payload })
    b.addCase(fetchMerchants.fulfilled, (s, a) => { s.loading.list = false;  s.list          = a.payload.data ?? [] })

    b.addCase(fetchMerchantById.pending,   (s)    => { s.loading.detail = true;  s.errors.detail = null })
    b.addCase(fetchMerchantById.rejected,  (s, a) => { s.loading.detail = false; s.errors.detail = a.payload })
    b.addCase(fetchMerchantById.fulfilled, (s, a) => { s.loading.detail = false; s.selected      = a.payload })

    b.addCase(updateMerchantStatus.fulfilled, (s, a) => {
      s.list = s.list.map(m => m.id === a.payload.id ? { ...m, status: a.payload.status } : m)
      if (s.selected?.id === a.payload.id) s.selected = { ...s.selected, status: a.payload.status }
    })
  },
})

export const { setMerchantFilter, resetMerchantFilters } = merchantsSlice.actions

export const selectMerchants        = (s) => s.merchants.list
export const selectSelectedMerchant = (s) => s.merchants.selected
export const selectMerchantsLoading = (s) => s.merchants.loading.list
export const selectMerchantFilters  = (s) => s.merchants.filters
export const selectMerchantErrors   = (s) => s.merchants.errors

export default merchantsSlice.reducer